import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

const CenterPanelUpdate = ({ isAdmin, setCurrentCheckboxValue, currentCheckboxValue, updateOrView }) => {
  let htmlToReactParser = new HtmlToReact.Parser(React);
  const handleOnChange = (event, data) => {
    if (updateOrView !== 'view') {
      setCurrentCheckboxValue(!currentCheckboxValue);
    }
  };
  return (
    <span>
      <div className={isAdmin == true ? 'ui form minHeightLargerForm' : 'ui form minHeightForm'}>
        {htmlToReactParser.parse(APP.LANGUAGE.ConsultNow.BodyMessage)}
        {true ? (
          <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
            <div className="toggle-box mrrs" onClick={handleOnChange}>
              <div className="toggle-text text-size-ms">
                {currentCheckboxValue ? window.APP.LANGUAGE.On : window.APP.LANGUAGE.Off}
              </div>
              <Checkbox toggle checked={currentCheckboxValue} disabled={updateOrView == 'view' ? true : false} />
            </div>
            {currentCheckboxValue && (
              <div className="ui no-bold title-sms pdtsss pdbxxs pdrnull txt-left checkBoxTextlhxx">
                {APP.LANGUAGE.ConsultNow.ConsultNowEnabledMessage}
              </div>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    </span>
  );
};

export default CenterPanelUpdate;
